import { useMemo } from 'react';
import { useGetLotSizingCriteria } from '@/services/apis/queries/lot-sizing/use-get-lot-sizing-criteria';
import { useLotSizingDraftPreview } from './use-lot-sizing-draft-preview';

type UseLotSizingFillRateParams = {
  lotSizingId: string;
};

export function useLotSizingFillRate({
  lotSizingId,
}: UseLotSizingFillRateParams) {
  const { data: criteria } = useGetLotSizingCriteria(lotSizingId);
  const { currentVolume, missingProductVolumes, noProductSelected } =
    useLotSizingDraftPreview(lotSizingId);

  const maxVolume = criteria.volumeTarget;

  const totalContainers = useMemo(
    () => (maxVolume > 0 ? Math.ceil(currentVolume / maxVolume) : 0),
    [currentVolume, maxVolume],
  );

  const totalVolume = maxVolume * totalContainers;
  const fillRate = totalVolume > 0 ? (currentVolume / totalVolume) * 100 : 0;

  return {
    currentVolume,
    fillRate,
    missingProductVolumes,
    noProductSelected,
    totalContainers,
    totalVolume,
  };
}
